import { render } from "./MarketplaceSignup.vue?vue&type=template&id=b858f9ba&scoped=true&lang=html"
import script from "./MarketplaceSignup.vue?vue&type=script&lang=js"
export * from "./MarketplaceSignup.vue?vue&type=script&lang=js"

import "./MarketplaceSignup.vue?vue&type=style&index=0&id=b858f9ba&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b858f9ba"]])

export default __exports__